import React from "react";
import PropTypes from "prop-types";
import { Col } from "reactstrap";

import { Datum } from "shared/react_components/DataList";

const OptionalDatumCol = ({ label, children, ...props }) =>
  !!children && (
    <Col md={6} lg={12} xl={6} className="mb-3" {...props}>
      <Datum label={label}>{children}</Datum>
    </Col>
  );

OptionalDatumCol.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node
};

export default OptionalDatumCol;
